import React from 'react'

const EventPublish = () => {
  return (
    <div>EventPublish</div>
  )
}

export default EventPublish